import { render, staticRenderFns } from "./cardComprehensive.vue?vue&type=template&id=759dab4e&"
import script from "./cardComprehensive.vue?vue&type=script&lang=js&"
export * from "./cardComprehensive.vue?vue&type=script&lang=js&"
import style0 from "./cardComprehensive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports